export class ApiUrlModel{
    id: string;
    dynamicArr:any[];
    username: string;
    pageSize:number;
    pageNo:number;
    type:string;
    keyword:string;
    bookingdate: string;
    email:string
    constructor(id:any,dynamicArr=[],username="",type="",keyword="",pageSize=10,pageNo=1, bookingdate="",email="") {
      this.id = id;
      this.dynamicArr = dynamicArr;
      this.username =username;
      this.type=type;
      this.pageSize =pageSize;
      this.pageNo=pageNo;
      this.keyword=keyword;
      this.bookingdate=bookingdate;
      this.email=email
    }
  }